import { WALLET_MODAL } from '../global-constants.js';
import { getMmdId, setDealerDRLeaseEnabled } from '../helpers/index.js';
import getDRAdminConfig from '../integrations/getDRAdminConfig.js';
import { loadScript } from '../utils/loadScript.js';
import { ddcLog } from '../utils/logger.js';

const PAGE_FOOTER_SELECTOR = '[data-location="page-footer"]';
const PAGE_FOOTER_POLL_INTERVAL = 50;
const PAGE_FOOTER_MAX_ATTEMPTS = 100;
const WRAPPER_CLASS = 'wallet-modal-wrapper';
const WRAPPER_LOCATION = 'wallet-modal-wrapper';

const waitForPageFooter = () => {
	return new Promise(resolve => {
		let attempts = 0;

		const checkForPageFooter = () => {
			attempts += 1;
			const pageFooter = document.querySelector(PAGE_FOOTER_SELECTOR);

			if (pageFooter) {
				ddcLog('Page footer found after', attempts, 'attempts');
				resolve(pageFooter);
				return;
			}

			if (attempts >= PAGE_FOOTER_MAX_ATTEMPTS) {
				ddcLog('WARNING: Page footer NOT found after', PAGE_FOOTER_MAX_ATTEMPTS, 'attempts. Falling back to document.body');
				resolve(document.body);
				return;
			}

			setTimeout(checkForPageFooter, PAGE_FOOTER_POLL_INTERVAL);
		};

		checkForPageFooter();
	});
};

const createWrapper = target => {
	const wrapper = document.createElement('div');
	wrapper.className = WRAPPER_CLASS;
	wrapper.setAttribute('data-location', WRAPPER_LOCATION);
	target.appendChild(wrapper);

	if (target.classList) {
		target.classList.remove('hide', 'hidden');
	}

	return wrapper;
};

export const insertWalletModal = async (walletScriptHost, config, vehicles, dealerData) => {

	const { enableLeasePayments, walletTheme } = config;
	let enablePaymentOption = false;

	if (enableLeasePayments && vehicles?.length > 0) {
		const mmdId = getMmdId(vehicles[0], dealerData);
		const drAdminConfig = mmdId ? await getDRAdminConfig(mmdId) : {};
		enablePaymentOption = drAdminConfig?.products?.hasLeasing;
	}

	const pageFooter = await waitForPageFooter();

	const walletModal = document.createElement(WALLET_MODAL);
	walletModal.style.position = 'relative';
	walletModal.style.zIndex = '1031';
	walletModal.style.display = 'block';

	if (walletTheme) {
		walletModal.setAttribute('theme', walletTheme);
		ddcLog('Set wallet theme:', walletTheme);
	}

	if (enablePaymentOption) {
		setDealerDRLeaseEnabled(true);
		walletModal.setAttribute('data-feature-flags', '{"wallet_payment_option": { "enabled": true }}');
		ddcLog('Payment options enabled on modal');
	} else {
		setDealerDRLeaseEnabled(false);
	}

	const insertTarget = createWrapper(pageFooter);
	insertTarget.appendChild(walletModal);

	const scriptUrl = `${walletScriptHost}/${WALLET_MODAL}.js`;

	await loadScript(scriptUrl);
};
